// extracted by mini-css-extract-plugin
export var container = "GlobalAlerts-module--container--84f8a";